(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("el-dynamic-form", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["el-dynamic-form"] = factory(require("vue"));
	else
		root["el-dynamic-form"] = factory(root["Vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__50154__) {
return 